import React from "react";

const ReportPreviewTable = ({ data, loading }) => {
  if (loading) {
    return <div className="text-muted">Loading preview...</div>;
  }

  if (!data || data.length === 0) {
    return (
      <div className="text-warning font-weight-bold mt-3">
        No data to preview.
      </div>
    );
  }

  const headers = Object.keys(data[0]);

  return (
    <div className="table-responsive mt-3">
      <table className="table table-bordered table-sm">
        <thead className="table-light">
          <tr>
            {headers.map((key) => (
              <th key={key}>{key}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.map((row, idx) => (
            <tr key={idx}>
              {headers.map((key) => (
                <td key={key}>{row[key]}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ReportPreviewTable;
